import { render } from "./NewFormGroup.vue?vue&type=template&id=54a586f0"
import script from "./NewFormGroup.vue?vue&type=script&lang=js"
export * from "./NewFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__